import { get, set } from "lodash-es";

import { GridColDef, GridColumnResizeParams } from "@mui/x-data-grid-pro";

interface SaveColumnWidth {
  mutateColumnWidths: (
    columns: GridColDef<any, any, any>[],
  ) => GridColDef<any, any, any>[];
  onColumnWidthChange: (change: GridColumnResizeParams) => void;
}

export const useSavedColumnWidths = (pageName: string): SaveColumnWidth => {
  const defaultWidths = JSON.parse(
    localStorage.getItem(pageName + "Widths") || "{}",
  );

  const mutateColumnWidths = (
    columns: GridColDef<any, any, any>[],
  ): GridColDef<any, any, any>[] => {
    return columns.map((c) => {
      const width = get(defaultWidths, c.field, false);
      if (width) {
        c.width = width;
        delete c.flex;
      }
      return c;
    });
  };

  const onColumnWidthChange = (change: GridColumnResizeParams): void => {
    const widths = JSON.parse(
      localStorage.getItem(pageName + "Widths") || "{}",
    );
    set(widths, change.colDef.field, change.width);
    localStorage.setItem(pageName + "Widths", JSON.stringify(widths));
  };

  return {
    mutateColumnWidths,
    onColumnWidthChange,
  };
};
